
import { Card } from "@/components/ui/card";
import { UploadStats } from "./types";

interface StatsCardsProps {
  stats: UploadStats;
}

export const StatsCards = ({ stats }: StatsCardsProps) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
      <Card className="p-3 bg-slate-50">
        <div className="flex flex-col items-center">
          <span className="text-sm text-slate-500">Total</span>
          <span className="text-2xl font-bold">{stats.total}</span>
        </div>
      </Card>
      
      <Card className="p-3 bg-green-50">
        <div className="flex flex-col items-center">
          <span className="text-sm text-green-700">Created</span>
          <span className="text-2xl font-bold text-green-700">{stats.created}</span>
        </div>
      </Card>
      
      <Card className="p-3 bg-blue-50">
        <div className="flex flex-col items-center">
          <span className="text-sm text-blue-700">Updated</span>
          <span className="text-2xl font-bold text-blue-700">{stats.updated}</span>
        </div>
      </Card>
      
      <Card className="p-3 bg-red-50">
        <div className="flex flex-col items-center">
          <span className="text-sm text-red-700">Failed</span>
          <span className="text-2xl font-bold text-red-700">{stats.errors}</span>
        </div>
      </Card>
    </div>
  );
};
